import React from 'react';
import { Beef, Wheat, CircleDot, Droplets, Flame, Calendar } from 'lucide-react';
import { mobileData as data } from '../data';

function StatCard({ icon: Icon, label, value, sub }: { icon: any; label: string; value: string; sub?: string }) {
  return (
    <div className="mb-card">
      <div className="mb-stat">
        <div className="mb-stat-icon">
          <Icon size={18} />
        </div>
        <div>
          <div className="mb-stat-value">{value}</div>
          <div className="mb-stat-label">{label}</div>
          {sub && <div className="mb-stat-sub">{sub}</div>}
        </div>
      </div>
    </div>
  );
}

function Pill({ children }: { children: React.ReactNode }) {
  return <span className="mb-pill">{children}</span>;
}

export default function HomePage() {
  const { macro_plan, program, progress_pics } = data;
  return (
    <div className="mb-stack">
      <div className="mb-grid2">
        <StatCard icon={Flame} label="Daily calories" value={`${macro_plan.calories_per_day} kcal`} sub={`${macro_plan.goal} • ${macro_plan.activity_level} activity`} />
        <StatCard icon={Calendar} label="Program" value={`${program.split}`} sub={`${program.days_per_week} days/wk • ${program.duration_weeks} wks`} />
      </div>

      <div className="mb-card">
        <div className="mb-card-head">
          <div className="mb-card-title">Hydration</div>
          <Droplets size={16} className="mb-muted" />
        </div>
        <div className="mb-row-between">
          <div>
            <div className="mb-big">24 fl oz</div>
            <div className="mb-muted">Goal: 80 fl oz</div>
          </div>
          <button className="mb-btn-secondary">+ 8 oz</button>
        </div>
      </div>

      <div>
        <div className="mb-section-title">Today’s macros</div>
        <div className="mb-grid3">
          <StatCard icon={Beef} label="Protein" value={`${macro_plan.protein_g}g`} />
          <StatCard icon={Wheat} label="Carbs" value={`${macro_plan.carbs_g}g`} />
          <StatCard icon={CircleDot} label="Fat" value={`${macro_plan.fat_g}g`} />
        </div>
      </div>

      <div className="mb-card">
        <div className="mb-card-head">
          <div className="mb-card-title">Progress photos</div>
        </div>
        <div className="mb-row-wrap">
          <Pill>Every {progress_pics.frequency_weeks} weeks</Pill>
          {progress_pics.poses.map((p) => (
            <Pill key={p.view}>{p.view}</Pill>
          ))}
        </div>
      </div>

      <div className="mb-tip">
        <div className="mb-tip-title">Tip</div>
        {program.notes}
      </div>
    </div>
  );
}


